module.exports = "<app-petition-menu></app-petition-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition.component.html
// module id = ./src/app/petition/petition.component.html
// module chunks = main